import React, {useState, useEffect} from 'react'

import { 
    API
} from 'aws-amplify'

import AppListItem from '../Action/AppListItem'

import {
    AppScrollContainerDiv,
    EmptyAppListContainerDiv,
    EmptyAppPhrase 
} from '../../Styles/Components/AppContainerStyles'

import * as queries from '../../graphql/queries'

import { useSelector } from "react-redux"

function AppListContainer(props){

    const [data, setData] = useState({});

    const hubPage = useSelector(state => state.hub.hubPage)

    var viewer
    var appCount = Object.keys(data).length

    useEffect(() => {
        switch(hubPage){
            case 'resume':
                API.graphql({ query: queries.listResumes})
                    .then(res=>{
                        if(res.data.listResumes.items.length !== 0){
                            setData({...data, resume: res.data.listResumes.items})
                        }
                    })
                break
            default:
                break
        }
    },[])
    
    if(appCount !== 0){
        viewer = (
            <AppScrollContainerDiv id="app-list-container-section">
                {data[hubPage].map(item => (
                    <AppListItem id={item.id} item={item} key={item.id} />
                ))}
            </AppScrollContainerDiv>
        )
    }
    else{
        viewer = (
            <>
                <EmptyAppListContainerDiv id='empty-app-list-container-section'>
                    <EmptyAppPhrase>No Items</EmptyAppPhrase>
                </EmptyAppListContainerDiv>
            </>
        )
    }
    
    return (
        <>
            {viewer}
        </>
    )

}

export default AppListContainer